import {  createSlice } from "@reduxjs/toolkit";
import { fetchStatus } from "./preferenceSlice";

const initialState = {
  pricingCardsData: [
    {
      id: "card1",
      name: "Trial",
      description: "Free credits to try the integration.",
      price: "DKK 0",
      points: [
        "15 trial credits",
        "Sync companies to Stripe",
        "Customize mapping",
      ],
    },
    {
      id: "card2",
      name: "Essential",
      description: "Free credits to try the integration.",
      price: "DKK 100",
      points: [
        "15 trial credits",
        "Sync companies to Stripe",
        "Customize mapping",
      ],
    },
  ],
  subscription: {
    loading: false,
    planDetails: {},
    error: "",
    currentRequestId: undefined,
  },
};

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    /**
     * Reducer updates the subscription details
     */
    updatePlanName(state, { payload }) {
      state.subscription.planDetails = {
        ...state.subscription.planDetails,
        plan: payload.plan,
        usageCount: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStatus.pending, (state, actions) => {
      if (!state.subscription.loading) {
        state.subscription.loading = true;
        state.subscription.currentRequestId = actions.meta.requestId;
      }
    });
    builder.addCase(fetchStatus.fulfilled, (state, actions) => {
      if (
        state.subscription.loading &&
        state.subscription.currentRequestId === actions.meta.requestId
      ) {
        state.subscription.loading = false;
        state.subscription.planDetails = actions.payload?.subscription;
        state.subscription.error = "";
        state.subscription.currentRequestId = undefined;
      }
    });
    builder.addCase(fetchStatus.rejected, (state, actions) => {
      if (
        state.subscription.loading &&
        state.subscription.currentRequestId === actions.meta.requestId
      ) {
        state.subscription.loading = false;
        state.subscription.planDetails = {};
        state.subscription.error = "";
        state.subscription.currentRequestId = undefined;
      }
    });
  },
});

export const { updatePlanName } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
